// Module
var code = "\n<div class=\"{{form.htmlClass}}\">{{form.value}}</div>";
// Exports
export default code;